<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading..."></mat-progress-bar>
</section>

<section *ngIf="!loading">
  <h2 class="noMarginHeader" *ngIf="applicationId == 0">
    <mat-icon>add</mat-icon> Add Voucher Application
  </h2>
  <h2 class="noMarginHeader" *ngIf="applicationId > 0 && !isIssued">
    <mat-icon>edit</mat-icon> Edit Voucher Application
  </h2>

  <form #form="ngForm" [formGroup]="voucherApplicationForm" class="form-field-full">
    <mat-tab-group dynamicHeight mat-align-tabs="begin" animationDuration="0ms" color="primary">
      <mat-tab label="Application">
        <br />

        <!-- Application Information -->
        <mat-card>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="1100" fxFlex.lt-sm="100">
              <mat-card-title>
                <span>Application Information </span>
              </mat-card-title>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <em>[<small *ngIf="application.selfGeneratedVoucherIdentifer != null && application.selfGeneratedVoucherIdentifer.length > 0"><strong>Survey123 ID:
                  </strong>{{application.selfGeneratedVoucherIdentifer}}</small>]</em>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100" fxLayoutAlign="end">
              <a href="../../../../assets/docs/VoucherEligibilityRules.docx" mat-raised-button matTooltipClass="tooltip"
                matTooltip="The link will download a Help document with Eligibility Rules for entering the Voucher Application manually">
                Help <mat-icon title="Voucher Application Help Document">help</mat-icon>
              </a>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Application Type</mat-label>
                <mat-select formControlName="applicationType" required (selectionChange)="typeChange()">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let item of applicationTypes" value="{{item}}">{{item}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <ul *ngIf="showWell || showHousingUnit || showHousehold" style="padding-left: 1.2em;">
                <li *ngIf="showWell && !wellAssociated && !voucherApplicationForm.value.createNewWell && voucherApplicationForm.value.selectedWellId == 0" class="error">
                  A Well is required for this Voucher. Update the Associate Well section below
                </li>
                <li *ngIf="showHousingUnit && !housingUnitAssociated && !voucherApplicationForm.value.createNewHousingUnit && voucherApplicationForm.value.selectedHousingUnitId == 0" class="error">
                  A Housing Unit is required for this Voucher. Update the Associate Housing Unit section
                </li>
                <li *ngIf="showHousehold && !householdAssociated && !voucherApplicationForm.value.createNewHousehold && voucherApplicationForm.value.selectedHouseholdId == 0" class="error">
                  A Household is required for this Voucher. Update the Associate Household section below
                </li>
              </ul>
              <mat-form-field appearance="standard">
                <mat-label>Status</mat-label>
                <mat-select formControlName="applicationStatus" (selectionChange)="voucherStatusChange()" required>
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let item of applicationStatuses" value="{{item}}">{{item}}</mat-option>
                  <mat-option *ngIf="showLubgwmaCard" value="Not Eligible">Not Eligible</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Application Source</mat-label>
                <mat-select formControlName="applicationSource">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let item of voucherService.applicationSources" value="{{item}}">{{item}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Canvasser Code</mat-label>
                <input type="text" placeholder="Canvasser Code" formControlName="canvasCode" matInput />
              </mat-form-field>
            </div>
          </div>

          <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="application.id > 0">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <small>Created on {{this.application.createDate}} by {{this.application.createdby}}</small>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <small>Last Updated on {{this.application.modifyDate}} by {{this.application.modifiedBy}}</small>
            </div>
          </div>
        </mat-card>

        <!-- Duplicate voucher search -->
        <mat-card *ngIf="canEdit">
          <mat-card-title>
            <button type="submit" (click)="voucherLookup();" mat-raised-button color="primary" title="Lookup existing Vouchers">Search Potential Duplicate Vouchers</button>
          </mat-card-title>


          <div fxLayout="row wrap" fxLayoutGap="8px grid" [hidden]="!showVoucherResults">

            <div fxFlex="100" fxFlex.lt-sm="100">
              <mat-table [dataSource]="dataSourceVouchers" matSort #TableSort="matSort" class="smallTable">
                <mat-header-row *matHeaderRowDef="displayedColumnsVouchers"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsVouchers;"></mat-row>
                <ng-container matColumnDef="id">
                  <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10" fxFlex.lt-sm="100">Voucher
                    Identifier</mat-header-cell>
                  <mat-cell *matCellDef="let result" fxFlex="10" fxFlex.lt-sm="100">
                    <a title="Edit Voucher {{result.applicationIdentifier}}" (click)="editVoucher(result.voucherId)">{{result.applicationIdentifier}}</a>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="applicationId">
                  <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="6" fxFlex.lt-sm="100">OHA Application Id</mat-header-cell>
                  <mat-cell *matCellDef="let result" fxFlex="6" fxFlex.lt-sm="100">
                    <span>{{result.voucherApplicationId}}</span>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="applicationStatus">
                  <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="6" fxFlex.lt-sm="10">Status</mat-header-cell>
                  <mat-cell *matCellDef="let result" fxFlex="6">
                    {{result.applicationStatus}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="applicationType">
                  <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="8" fxFlex.lt-sm="100">Type</mat-header-cell>
                  <mat-cell *matCellDef="let result" fxFlex="8" fxFlex.lt-sm="100">
                    {{result.applicationType}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="wellAddress">
                  <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="14" fxFlex.lt-sm="100">Address</mat-header-cell>
                  <mat-cell *matCellDef="let result" fxFlex="14" fxFlex.lt-sm="100">
                    {{result.wellAddress1}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="wellCity">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    {{result.wellCity}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="wellState">
                  <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="4" fxFlex.lt-sm="100">State</mat-header-cell>
                  <mat-cell *matCellDef="let result" fxFlex="4" fxFlex.lt-sm="100">
                    {{result.wellState}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="wellZip">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    {{result.wellZip}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="wellCounty">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    {{result.wellCounty}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="wellLog">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Well Log</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    {{result.wellLog}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="wellLabelTagNumber">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Well Tag</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    {{result.wellTag}}
                  </mat-cell>
                </ng-container>
              </mat-table>
            </div>
            <br />
          </div>

        </mat-card>

        <section *ngIf="showWildfireCard || showLubgwmaCard">

          <!-- Wildfire Eligibility Questions -->
          <mat-card *ngIf="showWildfireCard">
            <mat-card-title>
              <span>Eligibility Questions</span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">Property impacted by Oregon wildfires in Sept - Oct 2020?
                  </mat-label>
                  <mat-select formControlName="propertyImpacted">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes, there is fire damage on my property or within 1 mile of my property">Yes,
                      there is fire damage on my property or within 1 mile of my property</mat-option>
                    <mat-option value="No, fire was in my area but not within 1 mile of my property">No, fire was in my
                      area but not within 1 mile of my property</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">Previously received/used a voucher from OHA for the same well?
                  </mat-label>
                  <mat-select formControlName="previousVoucher">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                    <mat-option value="Unsure">Unsure</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <br />
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">Which wildfire(s) impacted your property?</mat-label>
                  <mat-select multiple formControlName="wildfire">
                    <mat-option *ngFor="let fire of voucherService.wildfireList" [value]="fire">{{ fire }}</mat-option>
                    <mat-option value="Other">Other
                      <span *ngIf="application.wildfireOther != null && application.wildfireOther != ''">
                        - {{application.wildfireOther}}
                      </span>
                    </mat-option>
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="text" placeholder="Other - Please specify wildfire(s)" formControlName="wildfireOther" style="width:95% !important" matInput />
                    <br /><br />
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">Household rely on private well for drinking, bathing, cooking?
                  </mat-label>
                  <mat-select formControlName="privateWellHoushold">
                    <mat-option value=""></mat-option>
                    <mat-option value="True">Yes</mat-option>
                    <mat-option value="False">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <br />
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">Property use a private well, or is it part of a public water
                    system?</mat-label>
                  <mat-select formControlName="privateWellProperty">
                    <mat-option value=""></mat-option>
                    <mat-option value="The well is part of a public water system. I pay a water bill.">The well is part
                      of
                      a public water system. I pay a water bill.</mat-option>
                    <mat-option value="The well is private. I own or rent the property and the well.">The well is
                      private.
                      I own or rent the property and the well.</mat-option>
                    <mat-option value="Unsure">Unsure</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">Well system &amp; plumbing have plastic or rubber components?
                  </mat-label>
                  <mat-select formControlName="wellSystemPlasticRubber">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                    <mat-option value="Unsure">Unsure</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <br />
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                Well or any of its components burned or heat-damaged?
                <br />
                <mat-radio-group formControlName="wellDamage" fxLayoutGap="4px grid">
                  <mat-radio-button value="Yes">Yes</mat-radio-button>
                  <br />
                  <mat-radio-button value="No">No</mat-radio-button>
                  <br />
                  <mat-radio-button value="Unsure">Unsure</mat-radio-button>
                  <br />
                  <mat-radio-button value="Other">Other</mat-radio-button>
                </mat-radio-group>
                <mat-form-field>
                  <input type="text" placeholder="Other - Please specify damage(s)" formControlName="wellDamageComments" style="width:95% !important" matInput />
                </mat-form-field>
              </div>
            </div>
          </mat-card>

          <!-- LUBGWMA Eligibility Questions -->
          <mat-card *ngIf="showLubgwmaCard">
            <mat-card-title>
              <span>Eligibility Questions</span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">Requesting OHA keep name and address confidential to the extent
                    permitted by law</mat-label>
                  <mat-select formControlName="confidential">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes">Yes, I am requesting that OHA keep my name and address confidential to the
                      extent permitted by law</mat-option>
                    <mat-option value="No">No, I am not requesting that OHA keep my name and address
                      confidential</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">Household rely on a private well for drinking, bathing,
                    etc?</mat-label>
                  <mat-select formControlName="householdPrivateWell">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes, the well is private. I own or rent the property and the well.">Yes, the well
                      is private. Own or rent the property and the well</mat-option>
                    <mat-option value="No, the well is part of a public water system. I pay a water bill.">No, the well
                      is part of a public water system. Pay a water bill</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">Property located within the LUBGWMA or Umatilla
                    counties?</mat-label>
                  <mat-select formControlName="propertyLocation">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes">Yes, property is within the Lower Umatilla Basin Groundwater Management Area
                      of Morrow or Umatilla County</mat-option>
                    <mat-option value="No">No, property is not within the Lower Umatilla Basin Groundwater Management
                      Area</mat-option>
                    <mat-option value="Unsure">Unsure</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">Morrow County Health Department or Umatilla County Public Health
                    tested well?</mat-label>
                  <mat-select formControlName="wellNitrateTest" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}
              
                {{tooltipMessage2}}">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes, Morrow County Health Department tested my well for nitrate.">Yes, Morrow
                      County Health Department tested my well for nitrate</mat-option>
                    <mat-option value="Yes, Umatilla County Public Health tested my well for nitrate.">Yes, Umatilla
                      County Public Health tested my well for nitrate</mat-option>
                    <mat-option value="No, the Counties did not test my well for nitrate.">No, the Counties did not test
                      my well for nitrate</mat-option>
                    <mat-option value="Unsure">Unsure</mat-option>
                    <mat-option value="Other">Other</mat-option>
                    &nbsp;&nbsp;&nbsp;
                    <input matInput formControlName="wellNitrateTestOther" style="width:95% !important" placeholder="Other">
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <br />
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">How did you learn about OHA's free well testing?</mat-label>
                  <mat-select formControlName="learnAboutVoucher" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}
              
                {{tooltipMessage2}}">
                    <mat-option value=""></mat-option>
                    <mat-option value="OHA website">OHA website</mat-option>
                    <mat-option value="Other website">Other website</mat-option>
                    <mat-option value="OHA press release">OHA press release</mat-option>
                    <mat-option value="Community event (fair, music festival, farmer's market)">Community event (fair,
                      music festival, farmer's market)</mat-option>
                    <mat-option value="Facebook post/group">Facebook post/group</mat-option>
                    <mat-option value="Twitter post">Twitter post</mat-option>
                    <mat-option value="Email">Email</mat-option>
                    <mat-option value="Radio">Radio</mat-option>
                    <mat-option value="Newspaper">Newspaper</mat-option>
                    <mat-option value="County Public Health Department">County Public Health Department</mat-option>
                    <mat-option value="Church">Church</mat-option>
                    <mat-option value="Workplace">Workplace</mat-option>
                    <mat-option value="Tribal health">Tribal health</mat-option>
                    <mat-option value="Grocery store, pharmacy">Grocery store, pharmacy</mat-option>
                    <mat-option value="Search Engine">Search Engine</mat-option>
                    <mat-option value="New Media">I saw an online notice (web advertising, online newspaper, Facebook or
                      other social media) </mat-option>
                    <mat-option value="Online Search">I did a search online </mat-option>
                    <mat-option value="Traditional Media">I heard a radio ad, saw a newspaper ad or saw a news
                      article</mat-option>
                    <mat-option value="Mail">I got information in the mail </mat-option>
                    <mat-option value="Community">I got information from my school, community organization, business or
                      workplace or at a community event</mat-option>
                    <mat-option value="Door to Door">Someone came door-to-door</mat-option>

                    <mat-option value="Other">Other</mat-option>
                    &nbsp;&nbsp;&nbsp;
                    <input matInput formControlName="learnAboutVoucherOther" style="width:95% !important" placeholder="Other">
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </mat-card>

          <!-- Voucher Identifier -->
          <mat-card *ngIf="canEdit && voucherApplicationForm.getRawValue().applicationStatus==voucherService.issued">
            <mat-card-title>
              <span>Voucher Identifier </span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">

              <mat-checkbox formControlName="selfGenerateVoucherIdentifier" (click)="confirmSelfGeneration()">
                <small>Create my own voucher idenfier</small>
              </mat-checkbox>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="showSelfGeneratedVoucherIdentifer">
              <mat-form-field>
                <input matInput placeholder="New Voucher Identifier" formControlName="selfGeneratedVoucherIdentifer">
              </mat-form-field>
            </div>
          </mat-card>

          <!-- Associate Well -->
          <mat-card *ngIf="showWell">
            <mat-card-title>
              <span>Associate Well </span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="!wellAssociated && !voucherApplicationForm.value.createNewWell && voucherApplicationForm.value.selectedWellId == 0">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <span class="error">
                  There is no Well associated with this Voucher Application
                </span>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="wellAssociated">
              <div fxFlex="100" fxFlex.lt-sm="100">
                This Voucher is associated to OHA Well Id:
                <a [routerLink]="['/well/edit/', application.selectedWellId]" title="OHA Well Id {{application.selectedWellId}}">{{application.selectedWellId}}</a>
                <br /><br />
                {{application.associatedWellAddress}}
                <br />
                {{application.associatedWellCity}}, {{application.associatedWellState}},
                {{application.associatedWellZip}}
                <br />
                {{application.associatedWellCounty}} <span *ngIf="application.associatedWellCounty != null">County</span>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="!wellAssociated">
              <div fxFlex="40" fxFlex.lt-sm="100">
                <br />
                <button type="submit" (click)="wellLookup('');" mat-raised-button color="primary" title="Lookup existing Well">Lookup existing Well</button>
                <br /><br />
                <mat-checkbox formControlName="createNewWell" (click)="showAssociatedWellResults();">
                  Create New Well <small>(fill out the Well Information section below)</small>
                </mat-checkbox>
              </div>
              <div fxFlex="60" fxFlex.lt-sm="100">
                <div *ngIf="showWellResultsDiv">
                  <h4 *ngIf="showWellResults" style="margin-bottom:0px;">Well Lookup Results</h4>
                  <small *ngIf="showWellResults">Results are based on the Well Information section below</small>
                  <br />
                  <mat-radio-group formControlName="selectedWellId">
                    <mat-table *ngIf="showWellResults" [dataSource]="dataSource" style="overflow-x: auto;" class="smallTable">
                      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                      <ng-container matColumnDef="wellId">
                        <mat-header-cell *matHeaderCellDef>OHA Well ID</mat-header-cell>
                        <mat-cell *matCellDef="let result">
                          <mat-radio-button value="{{result.data.wellId}}" (change)="selectedWellChange(result.wellId)">&nbsp;{{result.data.wellId}}</mat-radio-button>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="wellAddress1">
                        <mat-header-cell *matHeaderCellDef>Address 1</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.data.wellAddress1}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="wellCity">
                        <mat-header-cell *matHeaderCellDef>City</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.data.wellCity}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="wellState">
                        <mat-header-cell *matHeaderCellDef>State</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.data.wellState}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="wellZip">
                        <mat-header-cell *matHeaderCellDef>Zip</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.data.wellZip}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="wellCounty">
                        <mat-header-cell *matHeaderCellDef>County</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.data.wellCounty}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="wellLog">
                        <mat-header-cell *matHeaderCellDef>Well Log</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.data.wellLog}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="wellTag">
                        <mat-header-cell *matHeaderCellDef>Well Tag</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.data.wellTag}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="housingUnits">
                        <mat-header-cell *matHeaderCellDef># Housing Units</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.data.housingUnits.length}}</mat-cell>
                      </ng-container>
                    </mat-table>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </mat-card>

          <!-- Associate HousingUnit -->
          <mat-card *ngIf="showHousingUnit">
            <mat-card-title>
              <span>Associate Housing Unit</span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid"
              *ngIf="!housingUnitAssociated && !voucherApplicationForm.value.createNewHousingUnit && voucherApplicationForm.value.selectedHousingUnitId == 0">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <span class="error">
                  There is no Housing Unit associated with this Voucher Application and/or Well
                </span>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="!housingUnitAssociated">
              <div fxFlex="40" fxFlex.lt-sm="100">
                <br />
                <button type="submit" (click)="housingUnitLookup('');" mat-raised-button color="primary" title="Lookup existing Housing Unit">Lookup existing Housing Unit</button> <small> (based on
                  applicant
                  information below)</small>
                <br /><br />
                <mat-checkbox formControlName="createNewHousingUnit" (click)="createNewHousingUnitSelected();">
                  Create New Housing Unit<br><small>(pulled from the Applicant Information section below)</small>
                </mat-checkbox>
              </div>
              <div fxFlex="60" fxFlex.lt-sm="100">
                <div>
                  <h4 style="margin-bottom:0px;">Housing Unit Lookup Results</h4>
                  <small>Results are based on the associated Well or the Contact Information section below</small>
                  <br />
                  <mat-radio-group formControlName="selectedHousingUnitId">
                    <mat-table [dataSource]="dataSourceHousingUnit" style="overflow-x: auto;" class="smallTable">
                      <mat-header-row *matHeaderRowDef="displayedColumnsHousingUnit"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumnsHousingUnit;"></mat-row>
                      <ng-container matColumnDef="housingUnitId">
                        <mat-header-cell *matHeaderCellDef>Housing Unit Id</mat-header-cell>
                        <mat-cell *matCellDef="let result">
                          <mat-radio-button value="{{result.id}}" (change)="housingUnitSelectedChange(result.id)">{{result.id}} &nbsp;</mat-radio-button>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="contactName">
                        <mat-header-cell *matHeaderCellDef style="min-width: 100px;">Contact</mat-header-cell>
                        <mat-cell *matCellDef="let result" style="min-width: 100px;">{{result.contactName}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="address">
                        <mat-header-cell *matHeaderCellDef style="min-width: 200px;">Address</mat-header-cell>
                        <mat-cell *matCellDef="let result" style="min-width: 200px;">{{result.address1}} {{result.address2}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="city">
                        <mat-header-cell *matHeaderCellDef>City</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.city}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="zip">
                        <mat-header-cell *matHeaderCellDef>Zip</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.zip}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="county">
                        <mat-header-cell *matHeaderCellDef>County</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.county}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="score">
                        <mat-header-cell *matHeaderCellDef>% Match</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.score}}</mat-cell>
                      </ng-container>
                    </mat-table>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </mat-card>

          <!-- Associate Household -->
          <mat-card *ngIf="showHousehold">
            <mat-card-title>
              <span>Associate Household</span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="!housingUnitAssociated && !voucherApplicationForm.value.createNewHousehold && voucherApplicationForm.value.selectedHouseholdId == 0">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <span class="error">
                  There is no Household associated with this Voucher Application and/or Well
                </span>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="!householdAssociated">
              <div fxFlex="40" fxFlex.lt-sm="100">
                <br />
                <button type="submit" (click)="householdLookup('');" mat-raised-button color="primary" title="Lookup existing Household">Lookup existing Household</button> <small> (based on applicant
                  information below)</small>
                <br /><br />
                <mat-checkbox formControlName="createNewHousehold" (click)="createNewHouseholdSelected();">
                  Create New Household<br><small>(pulled from the Housing Unit and the applicant info
                    below)</small>
                </mat-checkbox>
              </div>
              <div fxFlex="60" fxFlex.lt-sm="100">
                <div>
                  <h4 style="margin-bottom:0px;">Household Lookup Results</h4>
                  <small>Results are based on the associated Housing Unit or the Contact Information section
                    below</small>
                  <br />
                  <mat-radio-group formControlName="selectedHouseholdId">
                    <mat-table [dataSource]="dataSourceHousehold" style="overflow-x: auto;" class="smallTable">
                      <mat-header-row *matHeaderRowDef="displayedColumnsHousehold"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumnsHousehold;"></mat-row>
                      <ng-container matColumnDef="householdId">
                        <mat-header-cell *matHeaderCellDef>Household Id</mat-header-cell>
                        <mat-cell *matCellDef="let result">
                          <mat-radio-button value="{{result.id}}" (change)="householdSelectedChange(result.id)">{{result.id}} &nbsp;</mat-radio-button>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="contactName">
                        <mat-header-cell *matHeaderCellDef style="min-width: 100px;">Contact</mat-header-cell>
                        <mat-cell *matCellDef="let result" style="min-width: 100px;">{{result.contactName}}</mat-cell>
                      </ng-container>
                      <!-- <ng-container matColumnDef="contactEmail">
                        <mat-header-cell *matHeaderCellDef>Email</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.contactEmail}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="contactPhone">
                        <mat-header-cell *matHeaderCellDef>Phone</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.contactPhone}}</mat-cell>
                      </ng-container> -->
                      <ng-container matColumnDef="address">
                        <mat-header-cell *matHeaderCellDef style="min-width: 200px;">Address</mat-header-cell>
                        <mat-cell *matCellDef="let result" style="min-width: 200px;">{{result.address1}} {{result.address2}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="city">
                        <mat-header-cell *matHeaderCellDef>City</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.city}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="zip">
                        <mat-header-cell *matHeaderCellDef>Zip</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.zip}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="county">
                        <mat-header-cell *matHeaderCellDef>County</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.county}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="score">
                        <mat-header-cell *matHeaderCellDef>% Match</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.score}}</mat-cell>
                      </ng-container>
                    </mat-table>
                  </mat-radio-group>
                </div>
              </div>
            </div>

          </mat-card>

          <!-- Well Information -->
          <mat-card>
            <mat-card-title>
              <span>Well Information</span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="25.00" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Well Address" formControlName="wellAddress">
                </mat-form-field>
              </div>
              <div fxFlex="25.00" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Well City" formControlName="wellCity">
                </mat-form-field>
              </div>
              <div fxFlex="25.00" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Well State" formControlName="wellState">
                </mat-form-field>
              </div>
              <div fxFlex="25.00" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Well Zip" formControlName="wellZip">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="25.00" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label>Well County</mat-label>
                  <mat-select id="wellCounty" name="wellCounty" formControlName="wellCounty">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.text}}">{{item.text}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="25.00" fxFlex.lt-sm="100">
                <mat-form-field>
                  <textarea matInput placeholder="Well Log" formControlName="wellLogNumber" matTooltipClass="tooltip" rows="1"
                    matTooltip="This is a combination of county name and numbers; for example, a well log in Marion County could be MARI-12345"></textarea>
                </mat-form-field>
              </div>
              <div fxFlex="25.00" fxFlex.lt-sm="100">
                <mat-form-field>
                  <textarea matInput placeholder="Well Tag" formControlName="wellLabelTagNumber" matTooltipClass="tooltip" rows="1"
                    matTooltip="Well label/tag number (L-#####). Wells built after 1996 should have a metal well tag on or near the wellhead"></textarea>
                </mat-form-field>
              </div>
              <div fxFlex="25.00" fxFlex.lt-sm="100">
                <button type="submit" (click)="pullApplicantAddress()" mat-raised-button color="primary" *ngIf="canEdit" title="Pull from Applicant Address" [disabled]='processing'>Pull from Applicant
                  Address</button>
              </div>
            </div>
          </mat-card>

          <!-- Applicant Information -->
          <mat-card>
            <mat-card-title>
              <span>Applicant Information</span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Applicant Name" formControlName="applicantContactName" required>
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Applicant Email" formControlName="applicantContactEmail">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Applicant Phone" formControlName="applicantContactPhone" required>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label>Preferred Contact Type</mat-label>
                  <mat-select formControlName="preferredContactType">
                    <mat-option value=""></mat-option>
                    <mat-option value="Email">Email</mat-option>
                    <mat-option value="Mail">Mail</mat-option>
                    <mat-option value="Phone">Phone</mat-option>
                    <mat-option value="Other">Other</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="66.66" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label>Preferred Contact Comments</mat-label>
                  <input matInput formControlName="preferredContactComments">
                </mat-form-field>
              </div>
            </div>
            <!-- Addresses -->
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                <mat-card>
                  <mat-card-title>
                    <span>Home Address</span>
                  </mat-card-title>
                  <div fxLayout="row wrap" fxLayoutGap="8px grid">
                    <div fxFlex="50" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <input matInput placeholder="Applicant Address" formControlName="applicantAddress" required>
                      </mat-form-field>
                    </div>
                    <div fxFlex="50" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <mat-label>Applicant Address Unit #</mat-label>
                        <input matInput placeholder="Applicant Address Unit #" formControlName="applicantAddressUnit">
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxLayout="row wrap" fxLayoutGap="8px grid">
                    <div fxFlex="25" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <input matInput placeholder="Applicant City" formControlName="applicantCity" required>
                      </mat-form-field>
                    </div>
                    <div fxFlex="25" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <input matInput placeholder="Applicant State" formControlName="applicantState" required>
                      </mat-form-field>
                    </div>
                    <div fxFlex="25" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <input matInput placeholder="Applicant Zip" formControlName="applicantZip" required>
                      </mat-form-field>
                    </div>
                    <div fxFlex="25" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <mat-label>Applicant County</mat-label>
                        <mat-select id="applicantCounty" name="applicantCounty" formControlName="applicantCounty">
                          <mat-option value=""></mat-option>
                          <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.text}}">{{item.text}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                <mat-card>
                  <mat-card-title>
                    <span>Mailing Address</span>
                  </mat-card-title>
                  <div fxLayout="row wrap" fxLayoutGap="8px grid">
                    <div fxFlex="100" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <input matInput placeholder="Mailing Address" formControlName="mailingAddress">
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxLayout="row wrap" fxLayoutGap="8px grid">
                    <div fxFlex="25" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <input matInput placeholder="Mailing City" formControlName="mailingCity">
                      </mat-form-field>
                    </div>
                    <div fxFlex="25" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <input matInput placeholder="Mailing State" formControlName="mailingState">
                      </mat-form-field>
                    </div>
                    <div fxFlex="25" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <input matInput placeholder="Mailing Zip" formControlName="mailingZip">
                      </mat-form-field>
                    </div>
                    <div fxFlex="25" fxFlex.lt-sm="100">
                      <mat-form-field>
                        <mat-label>Mailing County</mat-label>
                        <mat-select id="mailingCounty" name="mailingCounty" formControlName="mailingCounty">
                          <mat-option value=""></mat-option>
                          <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.text}}">{{item.text}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card>
              </div>
            </div>
          </mat-card>

          <!-- LUBGWMA Eligibility Questions -->
          <mat-card *ngIf="showLubgwmaCard">
            <mat-card-title>
              <span>Scheduling Questions </span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-label>Schedule a Test?&nbsp;&nbsp;</mat-label>
                <mat-checkbox formControlName="scheduleTest"></mat-checkbox>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="voucherApplicationForm.value.scheduleTest || application.scheduleTest"><br /></div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="voucherApplicationForm.value.scheduleTest || application.scheduleTest">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-label>Preferred Sample Days&nbsp;&nbsp;</mat-label>
                <mat-form-field>
                  <mat-select id="preferredSampleDays" name="preferredSampleDays" multiple formControlName="preferredSampleDays">
                    <mat-option *ngFor="let item of voucherService.preferredSampleDays" value="{{item}}">{{item}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-label>Preferred Sample Times&nbsp;&nbsp;</mat-label>
                <mat-form-field>
                  <mat-select id="preferredSampleTimes" name="preferredSampleTimes" multiple formControlName="preferredSampleTimes">
                    <mat-option *ngFor="let item of voucherService.preferredSampleTimes" value="{{item}}">{{item}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </mat-card>

          <!-- Wildfire Household Information -->
          <mat-card *ngIf="showWildfireCard">
            <mat-card-title>
              <span>Household Information</span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                Well property used as a primary residence by your household?
                <br />
                <mat-radio-group formControlName="primaryResidence" fxLayoutGap="4px grid">
                  <mat-radio-button value="Yes, this is the primary residence for my household or for full-time tenants">
                    Yes, this is the primary residence for my household or for full-time tenants
                  </mat-radio-button>
                  <br />
                  <mat-radio-button value="No, this is used as a second residence.">No, this is used as a second
                    residence.</mat-radio-button>
                  <br />
                  <mat-radio-button value="No, this is a vacation or rental property.">No, this is a vacation or rental
                    property.</mat-radio-button>
                  <br />
                  <mat-radio-button value="Other">Other</mat-radio-button>
                </mat-radio-group>
                <mat-form-field>
                  <input type="text" placeholder="Other - Please specify" formControlName="residenceOther" matInput />
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                How many individual households are served by this well?
                <br />
                <mat-radio-group formControlName="householdsServed" fxLayoutGap="4px grid">
                  <mat-radio-button value="1 household">1 household</mat-radio-button>
                  <br />
                  <mat-radio-button value="2 households">2 households</mat-radio-button>
                  <br />
                  <mat-radio-button value="3 households">3 households</mat-radio-button>
                  <br />
                  <mat-radio-button value="Other">Other</mat-radio-button>
                </mat-radio-group>
                <mat-form-field>
                  <input type="text" placeholder="Other - Please specify" formControlName="householdsServedOther" matInput />
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <mat-form-field>
                  <textarea rows="3" cols="100" formControlName="tenant" matInput class="drop-down-large"
                    placeholder="Tenant names, phone numbers or email addresses for all households served by this well"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">How many people are in your household?</mat-label>
                  <mat-select formControlName="householdSize" (selectionChange)="showHouseholdSize();" class="drop-down-large">
                    <mat-option value=""></mat-option>
                    <mat-option value="1 person">1 person</mat-option>
                    <mat-option value="2 people">2 people</mat-option>
                    <mat-option value="3 people">3 people</mat-option>
                    <mat-option value="4 people">4 people</mat-option>
                    <mat-option value="5 people">5 people</mat-option>
                    <mat-option value="6 people or more">6 people or more</mat-option>
                    <mat-option value="Prefer not to answer">Prefer not to answer</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" *ngIf="formHouseholdSize == 1">
                <mat-form-field>
                  <mat-label class="drop-down-large">One person household -annual income less than $16,588?</mat-label>
                  <mat-select formControlName="household1PersonIncome" class="drop-down-large">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes, I earn $16,588 or less a year">Yes, I earn $16,588 or less a year
                    </mat-option>
                    <mat-option value="No, I earn more that $16,588 a year">No, I earn more that $16,588 a year
                    </mat-option>
                    <mat-option value="Prefer not to answer">Prefer not to answer</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" *ngIf="formHouseholdSize == 2">
                <mat-form-field>
                  <mat-label class="drop-down-large">Two-person household - combined income of $22,412 or less?
                  </mat-label>
                  <mat-select formControlName="household1PersonIncome" class="drop-down-large">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes, my household earns $22,412 or less a year">Yes, my household earns $22,412
                      or
                      less a year</mat-option>
                    <mat-option value="No, my house hold earns more than $22,412 a year">No, my house hold earns more
                      than
                      $22,412 a year</mat-option>
                    <mat-option value="Prefer not to answer">Prefer not to answer</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" *ngIf="formHouseholdSize == 3">
                <mat-form-field>
                  <mat-label class="drop-down-large">Three-person household - annual combined income of $28,236 or less?
                  </mat-label>
                  <mat-select formControlName="household1PersonIncome" class="drop-down-large">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes, my household earns $28,236 or less a year">Yes, my household earns $28,236
                      or
                      less a year</mat-option>
                    <mat-option value="No, my household earns more than $28,236 a year">No, my household earns more than
                      $28,236 a year</mat-option>
                    <mat-option value="Prefer not to answer">Prefer not to answer</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" *ngIf="formHouseholdSize == 4">
                <mat-form-field>
                  <mat-label class="drop-down-large">Four-person household - annual combined income of $34,060 or less?
                  </mat-label>
                  <mat-select formControlName="household1PersonIncome" class="drop-down-large">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes, my household earns $34,060 or less a year">Yes, my household earns $34,060
                      or
                      less a year</mat-option>
                    <mat-option value="No, my household earns more than $34,060 a year">No, my household earns more than
                      $34,060 a year</mat-option>
                    <mat-option value="Prefer not to answer">Prefer not to answer</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" *ngIf="formHouseholdSize == 5">
                <mat-form-field>
                  <mat-label class="drop-down-large">Five-person household - annual combined income of $39,884 or less?
                  </mat-label>
                  <mat-select formControlName="household1PersonIncome" class="drop-down-large">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes, my household earns $39,884 or less a year">Yes, my household earns $39,884
                      or
                      less a year</mat-option>
                    <mat-option value="No, my household earns more than $39,884 a year">No, my household earns more than
                      $39,884 a year</mat-option>
                    <mat-option value="Prefer not to answer">Prefer not to answer</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" *ngIf="formHouseholdSize == 6">
                <mat-form-field>
                  <mat-label class="drop-down-large">Household of six or more - annual combined income $45,708 or less?
                  </mat-label>
                  <mat-select formControlName="household1PersonIncome" class="drop-down-large">
                    <mat-option value=""></mat-option>
                    <mat-option value="Yes, my household earns $45,708 or less a year">Yes, my household earns $45,708
                      or
                      less a year</mat-option>
                    <mat-option value="No, my household earns more than $45,708 a year">No, my household earns more than
                      $45,708 a year</mat-option>
                    <mat-option value="Prefer not to answer">Prefer not to answer</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </mat-card>

          <!-- LUBGWMA Household Information -->
          <mat-card *ngIf="showLubgwmaCard">
            <mat-card-title>
              <span>Household Information</span>
            </mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <span *ngIf="!lubgwmaValidationError">Does your household share a well with another property? *</span>
                <span *ngIf="lubgwmaValidationError" class="error">Does your household share a well with another
                  property? *</span>
                <br />
                <mat-radio-group formControlName="householdShared" fxLayoutGap="4px grid">
                  <mat-radio-button value="Yes">Yes</mat-radio-button>
                  <br />
                  <mat-radio-button value="No">No</mat-radio-button>
                  <br />
                  <mat-radio-button value="Unsure">Unsure</mat-radio-button>
                </mat-radio-group>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <span>Residence Type </span>
                <br />
                <mat-radio-group formControlName="residenceType" fxLayoutGap="4px grid">
                  <mat-radio-button value="Rent">Rent</mat-radio-button>
                  <br />
                  <mat-radio-button value="Own">Own</mat-radio-button>
                  <br />
                  <mat-radio-button value="Other">Other</mat-radio-button>&nbsp;
                  <input matInput placeholder="Residence Other" formControlName="residenceTypeOther" *ngIf="voucherApplicationForm.get('residenceType').value == 'Other'">
                </mat-radio-group>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <mat-form-field>
                  <textarea rows="3" cols="100" formControlName="tenant" matInput class="drop-down-large"
                    placeholder="Contact names and phone numbers or email addresses for all households served by this well"></textarea>
                </mat-form-field>
                <br />
              </div>
            </div>
            <!-- <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">How many people are in your household?</mat-label>
                  <mat-select formControlName="householdSize" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}
              
                {{tooltipMessage2}}">
                    <mat-option value=""></mat-option>
                    <mat-option value="1 person">1 person</mat-option>
                    <mat-option value="2 people">2 people</mat-option>
                    <mat-option value="3 people">3 people</mat-option>
                    <mat-option value="4 people">4 people</mat-option>
                    <mat-option value="5 people">5 people</mat-option>
                    <mat-option value="6 people">6 people</mat-option>
                    <mat-option value="7 people">7 people</mat-option>
                    <mat-option value="8 people">8 people</mat-option>
                    <mat-option value="9 people">9 people</mat-option>
                    <mat-option value="10 people">10 people</mat-option>
                    <mat-option value="Other">Other</mat-option>
                    &nbsp;&nbsp;&nbsp;
                    <input matInput formControlName="householdSizeOther" style="width:95% !important"
                      placeholder="Other">
                  </mat-select>
                </mat-form-field>
              </div>
            </div> -->
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">How many people in your household are age 15 and
                    younger?</mat-label>
                  <input type="text" placeholder="How many people in your household are age 15 and younger?" formControlName="age15AndBelow" matInput />
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label class="drop-down-large">How many people in your household are age 16 and older?</mat-label>
                  <input type="text" placeholder="How many people in your household are age 16 and older?" formControlName="age16AndAbove" matInput />
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <span>Is anyone in your household pregnant or may become pregnant?</span> <br />

                <mat-radio-group formControlName="pregnancyInHousehold" fxLayoutGap="4px grid">
                  <mat-radio-button value="true">Yes</mat-radio-button>
                  <br />
                  <mat-radio-button value="false">No</mat-radio-button>
                </mat-radio-group>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <span>Are there any babies or small children in your household age 2 or younger?</span> <br />

                <mat-radio-group formControlName="infantsInHousehold" fxLayoutGap="4px grid">
                  <mat-radio-button value="true">Yes</mat-radio-button>
                  <br />
                  <mat-radio-button value="false">No</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </mat-card>
        </section>
      </mat-tab>

      <mat-tab label="Real-D">
        <br />

        <!-- REAL-D Information -->
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
            <mat-card>
              <mat-card-title>
                <span>Real-D Information</span>
              </mat-card-title>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="100" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Would you like to tell us your race, ethnicity, language and
                      ability levels?</mat-label>
                    <mat-select formControlName="volunteerRaceEthInfo">
                      <mat-option value=""></mat-option>
                      <mat-option value="True">Yes</mat-option>
                      <mat-option value="False">No</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="100" fxFlex.lt-sm="100">
                  How do you identify your race, ethnicity, tribal affiliation, country of origin, or ancestry?
                </div>
                <br /><br />
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <!-- #region Hispanic and Latino/a/x -->
                  <small><strong>Hispanic and Latino/a/x</strong></small>
                  <br />
                  <mat-checkbox formControlName="centralAmerican" (click)="setPrimaryRaceEthnicity('centralAmerican')">
                    <small>Central American</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="mexican" (click)="setPrimaryRaceEthnicity('mexican')">
                    <small>Mexican</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="southAmerican" (click)="setPrimaryRaceEthnicity('southAmerican')">
                    <small>South American</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="otherLatinx" (click)="setPrimaryRaceEthnicity('otherLatinx')">
                    <small>Other Hispanic or Latino/a/x</small>
                  </mat-checkbox>
                  <!-- #endregion -->

                  <br /><br />

                  <!-- #region Native Hawaiian and Pacific Islander -->
                  <small><strong>Native Hawaiian and Pacific Islander</strong></small>
                  <br />
                  <mat-checkbox formControlName="chamoru" (click)="setPrimaryRaceEthnicity('chamoru')">
                    <small>CHamoru (Chamorro)</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="marshallese" (click)="setPrimaryRaceEthnicity('marshallese')">
                    <small>Marshallese</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="micronesian" (click)="setPrimaryRaceEthnicity('micronesian')">
                    <small>Communities of the Micronesian Region</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="nativeHawaiian" (click)="setPrimaryRaceEthnicity('nativeHawaiian')">
                    <small>Native Hawaiian</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="samoan" (click)="setPrimaryRaceEthnicity('samoan')">
                    <small>Samoan</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="otherPacificIslander" (click)="setPrimaryRaceEthnicity('otherPacificIslander')">
                    <small>Other Pacific Islander</small>
                  </mat-checkbox>
                  <!-- #endregion -->

                  <br /><br />

                  <!-- #region White -->
                  <small><strong>White</strong></small>
                  <br />
                  <mat-checkbox formControlName="easternEuropean" (click)="setPrimaryRaceEthnicity('easternEuropean')">
                    <small>White - Eastern European</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="slavic" (click)="setPrimaryRaceEthnicity('slavic')">
                    <small>White - Slavic</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="westernEuropean" (click)="setPrimaryRaceEthnicity('westernEuropean')">
                    <small>White - Western European</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="otherWhite" (click)="setPrimaryRaceEthnicity('otherWhite')">
                    <small>White - Other White</small>
                  </mat-checkbox>
                  <!-- #endregion -->
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <!-- #region American Indian and Alaska Native -->
                  <small><strong>American Indian and Alaska Native</strong></small>
                  <br />
                  <mat-checkbox formControlName="americanIndian" (click)="setPrimaryRaceEthnicity('americanIndian')">
                    <small>American Indian</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="alaskaNative" (click)="setPrimaryRaceEthnicity('alaskaNative')">
                    <small>Alaska Native</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="canadianFirstNation" (click)="setPrimaryRaceEthnicity('canadianFirstNation')">
                    <small>Canadian Inuit, Metis, or First Nation</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="indigenousCentralAmerican" (click)="setPrimaryRaceEthnicity('indigenousCentralAmerican')">
                    <small>Indigenous Mexican, Central American, <br />or South American</small>
                  </mat-checkbox>
                  <!-- #endregion -->

                  <br /><br />

                  <!-- #region Black and African American -->
                  <small><strong>Black and African American</strong></small>
                  <br />
                  <mat-checkbox formControlName="africanAmerican" (click)="setPrimaryRaceEthnicity('africanAmerican')">
                    <small>African American</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="afroCarribbean" (click)="setPrimaryRaceEthnicity('afroCarribbean')">
                    <small>Afro-Caribbean</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="ethiopian" (click)="setPrimaryRaceEthnicity('ethiopian')">
                    <small>Ethiopian</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="somali" (click)="setPrimaryRaceEthnicity('somali')">
                    <small>Somali</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="otherAfrican" (click)="setPrimaryRaceEthnicity('otherAfrican')">
                    <small>Other African (Black)</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="otherBlack" (click)="setPrimaryRaceEthnicity('otherBlack')">
                    <small>Other Black</small>
                  </mat-checkbox>
                  <!-- #endregion -->

                  <br /><br />

                  <!-- #region Middle Eastern/North African -->
                  <small><strong>Middle Eastern/North African</strong></small>
                  <br />
                  <mat-checkbox formControlName="middleEastern" (click)="setPrimaryRaceEthnicity('middleEastern')">
                    <small>Middle Eastern</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="northAfrican" (click)="setPrimaryRaceEthnicity('northAfrican')">
                    <small>North African</small>
                  </mat-checkbox>
                  <!-- #endregion -->
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <!-- #region Asian -->
                  <small><strong>Asian</strong></small>
                  <br />
                  <mat-checkbox formControlName="asianIndian" (click)="setPrimaryRaceEthnicity('asianIndian')">
                    <small>Asian Indian</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="cambodian" (click)="setPrimaryRaceEthnicity('cambodian')">
                    <small>Cambodian</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="chinese" (click)="setPrimaryRaceEthnicity('chinese')">
                    <small>Chinese</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="myanmar" (click)="setPrimaryRaceEthnicity('myanmar')">
                    <small>Communities of Myanmar</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="filipino" (click)="setPrimaryRaceEthnicity('filipino')">
                    <small>Filipino/a</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="hmong" (click)="setPrimaryRaceEthnicity('hmong')">
                    <small>Hmong</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="japanese" (click)="setPrimaryRaceEthnicity('japanese')">
                    <small>Japanese</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="korean" (click)="setPrimaryRaceEthnicity('korean')">
                    <small>Korean</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="laotian" (click)="setPrimaryRaceEthnicity('laotian')">
                    <small>Laotian</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="southAsian" (click)="setPrimaryRaceEthnicity('southAsian')">
                    <small>South Asian</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="vietnamese" (click)="setPrimaryRaceEthnicity('vietnamese')">
                    <small>Vietnamese</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="otherAsian" (click)="setPrimaryRaceEthnicity('otherAsian')">
                    <small>Other Asian</small>
                  </mat-checkbox>
                  <!-- #endregion -->

                  <br /><br />

                  <!-- #region Other categories -->
                  <small><strong>Other categories</strong></small>
                  <br />
                  <mat-checkbox formControlName="dontKnow" (click)="setPrimaryRaceEthnicity('dontKnow')">
                    <small>Don't know</small>
                  </mat-checkbox>
                  <br />
                  <mat-checkbox formControlName="raceEthDecline" (click)="setPrimaryRaceEthnicity('raceEthDecline')">
                    <small>Don't want to answer</small>
                  </mat-checkbox>
                  <br />
                  <mat-form-field style="width:150px !important; margin-top:5px;">
                    <input matInput placeholder="Other" formControlName="raceEthOther">
                  </mat-form-field>
                  <!-- #endregion -->
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Is there one you think of as your primary racial or ethnic
                      identity?</mat-label>
                    <mat-select formControlName="raceEthPrimary">
                      <mat-option value=""></mat-option>
                      <mat-option value="I do not have just one primary racial or ethnic identity">I do not have just
                        one primary racial or ethnic identity</mat-option>
                      <mat-option value="No, I identify as Biracial or Multiracial">No, I identify as Biracial or
                        Multiracial</mat-option>
                      <mat-option value="N/A. I only checked one category">N/A. I only checked one category
                      </mat-option>
                      <ng-container *ngIf="primaryRaceEthnicity.length > 0">
                        <mat-option *ngFor="let item of primaryRaceEthnicity" value="{{item.value}}">{{item.value}}
                        </mat-option>
                      </ng-container>
                      <mat-option *ngIf="voucherApplicationForm.value.raceEthOther != null && voucherApplicationForm.value.raceEthOther != ''"
                        value="application.raceEthOther">{{voucherApplicationForm.value.raceEthOther}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">How well do you speak English?</mat-label>
                    <mat-select id="englishProficiency" name="englishProficiency" formControlName="englishProficiency">
                      <mat-option value=""></mat-option>
                      <mat-option value="Very well">Very well</mat-option>
                      <mat-option value="Well">Well</mat-option>
                      <mat-option value="Not well">Not well</mat-option>
                      <mat-option value="Not at all">Not at all</mat-option>
                      <mat-option value="Don't know">Don't know</mat-option>
                      <mat-option value="Don't want to answer">Don't want to answer</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  What language or languages do you use at home?
                  <br />
                  <mat-radio-group formControlName="languagAtHome" fxLayoutGap="4px grid">
                    <mat-radio-button value="True">English only</mat-radio-button>
                    <br />
                    <mat-radio-button value="False">Other</mat-radio-button>
                  </mat-radio-group>
                  <mat-form-field>
                    <input type="text" placeholder="Other - Please specify" formControlName="languageAtHomeOther" matInput />
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Language to communicate in person, on the phone, or virtually
                      with you?</mat-label>
                    <input matInput formControlName="languageSpoken">
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Language do you want us to write to you?</mat-label>
                    <input matInput formControlName="languageWritten">
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Do you need or want an interpreter for us to communicate with
                      you?</mat-label>
                    <mat-select id="needInterpreter" name="needInterpreter" formControlName="needInterpreter">
                      <mat-option value=""></mat-option>
                      <mat-option value="Yes">Yes</mat-option>
                      <mat-option value="No">No</mat-option>
                      <mat-option value="Don't Know">Don't Know</mat-option>
                      <mat-option value="Don't want to answer">Don't want to answer</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">If you need or want an interpreter, what type of interpreter is
                      preferred?</mat-label>
                    <mat-select id="needInterpreterType" name="needInterpreterType" formControlName="needInterpreterType" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}

                      {{tooltipMessage2}}">
                      <mat-option value=""></mat-option>
                      <mat-option value="Spoken language interpreter">Spoken language interpreter</mat-option>
                      <mat-option value="American Sign Language interpreter">American Sign Language
                        interpreter</mat-option>
                      <mat-option value="Deaf interpreter for Deaf/Blind, additional barriers, or both">
                        Deaf interpreter for Deaf/Blind, additional barriers, or both</mat-option>
                      <mat-option value="Contact sign language (PSE) interpreter">Contact sign language
                        (PSE)interpreter</mat-option>
                      <mat-option value="Other">Other</mat-option>
                      &nbsp;&nbsp;&nbsp;
                      <input matInput id="needInterpreterTypeOther" name="needInterpreterTypeOther" formControlName="needInterpreterTypeOther" style="width:95% !important"
                        placeholder="Other interpreter comments">
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Are you deaf or do you have serious difficulty hearing?
                    </mat-label>
                    <mat-select id="hearing" name="hearing" formControlName="hearing" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}
                      
                      {{tooltipMessage2}}">
                      <mat-option value=""></mat-option>
                      <mat-option value="Yes">Yes</mat-option>
                      <mat-option value="No">No</mat-option>
                      <mat-option value="Don't know">Don't know</mat-option>
                      <mat-option value="Don't want to answer">Don't want to answer</mat-option>
                      <mat-option value="Other">Other</mat-option>
                      &nbsp;&nbsp;&nbsp;
                      <input matInput id="hearingComments" name="hearingComments" formControlName="hearingComments" placeholder="Other hearing comments" style="width:95% !important">
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Blind or do you have serious difficulty seeing, even
                      when wearing glasses?</mat-label>
                    <mat-select id="vision" name="vision" formControlName="vision" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}
                      
                      {{tooltipMessage2}}">
                      <mat-option value=""></mat-option>
                      <mat-option value="Yes">Yes</mat-option>
                      <mat-option value="No">No</mat-option>
                      <mat-option value="Don't know">Don't know</mat-option>
                      <mat-option value="Don't want to answer">Don't want to answer</mat-option>
                      <mat-option value="Other">Other</mat-option>
                      &nbsp;&nbsp;&nbsp;
                      <input matInput id="visionComments" name="visionComments" formControlName="visionComments" style="width:95% !important" placeholder="Other vision comments">
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Do you have serious difficulty walking or climbing stairs?
                    </mat-label>
                    <mat-select id="mobility" name="mobility" formControlName="mobility" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}
                      
                      {{tooltipMessage2}}">
                      <mat-option value=""></mat-option>
                      <mat-option value="Yes">Yes</mat-option>
                      <mat-option value="No">No</mat-option>
                      <mat-option value="Don't know">Don't know</mat-option>
                      <mat-option value="Don't want to answer">Don't want to answer</mat-option>
                      <mat-option value="Other">Other</mat-option>
                      &nbsp;&nbsp;&nbsp;
                      <input matInput id="mobilityComments" name="mobilityComments" formControlName="mobilityComments" placeholder="Other mobility comments" style="width:95% !important">
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Difficulty concentrating, remembering, or making decisions?
                    </mat-label>
                    <mat-select id="focus" name="focus" formControlName="focus" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}
                    
                      {{tooltipMessage2}}">
                      <mat-option value=""></mat-option>
                      <mat-option value="Yes">Yes</mat-option>
                      <mat-option value="No">No</mat-option>
                      <mat-option value="Don't know">Don't know</mat-option>
                      <mat-option value="Don't want to answer">Don't want to answer</mat-option>
                      <mat-option value="Other">Other</mat-option>
                      &nbsp;&nbsp;&nbsp;
                      <input matInput id="focusComment" name="focusComment" formControlName="focusComment" placeholder="Other focus comments" style="width:95% !important">
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Do you have difficulty dressing or bathing?</mat-label>
                    <mat-select id="dressingBathing" name="dressingBathing" formControlName="dressingBathing" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}
                    
                      {{tooltipMessage2}}">
                      <mat-option value=""></mat-option>
                      <mat-option value="Yes">Yes</mat-option>
                      <mat-option value="No">No</mat-option>
                      <mat-option value="Don't know">Don't know</mat-option>
                      <mat-option value="Don't want to answer">Don't want to answer</mat-option>
                      <mat-option value="Other">Other</mat-option>
                      &nbsp;&nbsp;&nbsp;
                      <input matInput id="dressingBathingComments" name="dressingBathingComments" formControlName="dressingBathingComments" style="width:95% !important"
                        placeholder="Other dressing or bathing comments">
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Difficulty learning how to do things most people your age can
                      learn?</mat-label>
                    <mat-select id="learning" name="learning" formControlName="learning" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}
                    
                      {{tooltipMessage2}}">
                      <mat-option value=""></mat-option>
                      <mat-option value="Yes">Yes</mat-option>
                      <mat-option value="No">No</mat-option>
                      <mat-option value="Don't know">Don't know</mat-option>
                      <mat-option value="Don't want to answer">Don't want to answer</mat-option>
                      <mat-option value="Other">Other</mat-option>
                      &nbsp;&nbsp;&nbsp;
                      <input matInput id="learningComments" name="learningComments" formControlName="learningComments" style="width:95% !important" placeholder="Other learning comments">
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  Using customary language, do you have difficulty communicating?
                  <br />
                  <mat-radio-group formControlName="communication" fxLayoutGap="4px grid">
                    <mat-radio-button value="Yes">Yes</mat-radio-button>
                    <br />
                    <mat-radio-button value="No">No</mat-radio-button>
                    <br />
                    <mat-radio-button value="Don't know">Don't know</mat-radio-button>
                    <br />
                    <mat-radio-button value="Don't want to answer">Don't want to answer</mat-radio-button>
                    <br />
                    <mat-radio-button value="Don't know what this question is asking">Don't know what this question is
                      asking</mat-radio-button>
                    <br />
                    <mat-radio-button value="Other">Other</mat-radio-button>
                  </mat-radio-group>
                  <mat-form-field>
                    <input type="text" placeholder="Other - Please specify" formControlName="communicationComments" matInput />
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-sm="100">
                  Difficulty with mood, feelings, behavior, delusions or hallucinations?
                  <br />
                  <mat-radio-group formControlName="moods" fxLayoutGap="4px grid">
                    <mat-radio-button value="Yes">Yes</mat-radio-button>
                    <br />
                    <mat-radio-button value="No">No</mat-radio-button>
                    <br />
                    <mat-radio-button value="Don't know">Don't know</mat-radio-button>
                    <br />
                    <mat-radio-button value="Don't want to answer">Don't want to answer</mat-radio-button>
                    <br />
                    <mat-radio-button value="Don't know what this question is asking">Don't know what this question is
                      asking</mat-radio-button>
                    <br />
                    <mat-radio-button value="Other">Other</mat-radio-button>
                  </mat-radio-group>
                  <mat-form-field>
                    <input type="text" placeholder="Other - Please specify" formControlName="moodsComments" matInput />
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="50" fxFlex.lt-sm="100">
                  <mat-form-field>
                    <mat-label class="drop-down-large">Difficulty doing errands alone such as visiting a doctor's
                      office or shopping?</mat-label>
                    <mat-select id="selfSupport" name="selfSupport" formControlName="selfSupport" matTooltipClass="tooltip" matTooltip="{{tooltipMessage1}}
                    
                      {{tooltipMessage2}}">
                      <mat-option value=""></mat-option>
                      <mat-option value="Yes">Yes</mat-option>
                      <mat-option value="No">No</mat-option>
                      <mat-option value="Don't know">Don't know</mat-option>
                      <mat-option value="Don't want to answer">Don't want to answer</mat-option>
                      <mat-option value="Other">Other</mat-option>
                      &nbsp;&nbsp;&nbsp;
                      <input matInput id="selfSupportComments" name="selfSupportComments" formControlName="selfSupportComments" style="width:95% !important" placeholder="Other errands comments">
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Letters" *ngIf="application.id > 0 && application.applicationStatus != voucherService.issued">
        <br />
        <voucher-letters [applicationId]="application.id"></voucher-letters>
      </mat-tab>
    </mat-tab-group>
    <div>
      <button type="submit" (click)="onSubmit()" mat-raised-button color="primary" title="{{buttonText}}" [disabled]='processing || authService.isReadOnly()'>{{buttonText}}</button>
    </div>
  </form>
</section>